export default __webpack_public_path__ + "static/media/ss4.1ff7526e.png";